// extracted by mini-css-extract-plugin
module.exports = {"popStyle":"insertemoji_popStyle__YWOu5"};